import Cancel from '@mui/icons-material/Cancel'
import CheckCircle from '@mui/icons-material/CheckCircle'
import Edit from '@mui/icons-material/Edit'
import { TextareaAutosize } from '@mui/material'
import React, { useEffect, useRef, useState } from 'react'
import { IconButton } from '@mui/material'

export default function GenericDrugComponent({ setSelectedDrug, selectedDrug }) {
  const [editing, setEditing] = useState(false)


  return (
    selectedDrug && (
      <div
        style={{
          color: '#9e9e9e',
          fontSize: '12px',
          display: 'flex',
          gap: '8px',
          background: '#fff',
          alignItems: 'center',
          justifyContent: 'flex-start',
          textAlign: 'left',
          padding: '4px 4px',
          borderLeft: '1px solid #CCC',
          borderRight: '1px solid #CCC',
          width: '100%',
          position: 'relative',
          zIndex: 0, // Lower than Frequency column (zIndex: 25) to appear behind it
        }}
      >
        {!editing && (
          <Edit
            style={{  fontSize: '16px', cursor: 'pointer' }}
            onClick={() => {
              setEditing((prev) => !prev)
            }}
          />
        )}
        {editing ? (
          <EditGenericName
            currentGenericName={selectedDrug?.genericName}
            handleSubmit={(changedDrug) => {
              //check if the generic name is changed, then put a flag in drug, _genericNameChanged: true
              setSelectedDrug({ ...selectedDrug, genericName: changedDrug })
              setEditing((prev) => !prev)
            }}
          />
        ) : (
          <div>{selectedDrug?.genericName || 'Generic Name'}</div>
        )}
      </div>
    )
  )
}

function EditGenericName({ currentGenericName, handleSubmit }) {
  const [currentGenericDrug, setCurrentGenericDrug] = useState(currentGenericName)
  const textAreaRef = useRef(null)

  useEffect(() => {
    if (textAreaRef.current) {
      textAreaRef.current.focus()
      const length = textAreaRef.current.value.length
      textAreaRef.current.setSelectionRange(length, length) // Move cursor to end
    }
  }, [])

  return (
    <div className="d-flex align-items-center w-100 border" style={{ borderRadius: '4px' }}>
      <TextareaAutosize
        ref={textAreaRef}
        style={{
          resize: 'none', // Disable manual resizing
          overflow: 'hidden', // Auto-expand height
          outline: 'none',
          width: '100%',
          color: '#656565',
        }}
        value={currentGenericDrug}
        onChange={(e) => {
          setCurrentGenericDrug(e.target.value)
        }}
      />
      <IconButton
        sx={{ padding: '0px' }}
        onClick={() => handleSubmit(currentGenericDrug)}
        color="success"
      >
        <CheckCircle style={{ fontSize: '16px' }} />
      </IconButton>
    </div>
  )
}
